import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import GLOBE from 'vanta/dist/vanta.globe.min';
import * as THREE from 'three';
import './Service.scss';

const Service: React.FC = () => {
  const { t } = useTranslation();
  const vantaRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!vantaRef.current) {
      return;
    }

    const effect = GLOBE({
      el: vantaRef.current,
      THREE,
      color: 0x1890ff,
      backgroundColor: 0x0b1220,
      size: 1.05,
    });

    return () => {
      effect?.destroy();
    };
  }, []);

  return (
    <div className="service-page">
      <div className="service-bg" ref={vantaRef} aria-hidden="true" />
      <div className="service-content">
        <h1>{t('service')}</h1>
        <h2>{t('servicesTitle')}</h2>
        <ul>
          {(t('mainServices', { returnObjects: true }) as string[]).map((service: string, index: number) => (
            <li key={index}>{service}</li>
          ))}
        </ul>
        <p>{t('techServicesIntro')}</p>
        <ul>
          {(t('techServicesList', { returnObjects: true }) as string[]).map((service: string, index: number) => (
            <li key={index}>{service}</li>
          ))}
        </ul>
        <p className="service-contact">{t('contactInfo')}</p>
      </div>
    </div>
  );
};

export default Service;